module.exports = __webpack_public_path__ + "static/urban2-99d396ec6e3f7181496f408cf33497f4.jpg";